export default __webpack_public_path__ + "static/media/default.392cbc25.jpg";